module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', {
    staticClass: "w4"
  }, [_c('Multiselect', {
    attrs: {
      "value": _vm.selectedCountryCurrency,
      "options": _vm.countriesList,
      "searchable": false,
      "allow-empty": false,
      "deselect-label": "",
      "selectLabel": "",
      "track-by": "id",
      "label": "currency_code"
    },
    on: {
      "input": _vm.setCurrentCountryCurrency
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4738c58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CoverageCurrencyToggle.vue
// module id = 554
// module chunks = 0